export default {
  route: {
    dashboard: '首页',
    Table: '列表'
  },
  navbar: {
    logOut: '退出登录',
    dashboard: '首页'
  },
  login: {
    title: '系统登录',
    logIn: '登录',
    username: '账号',
    password: '密码'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  }
}
